import { useContext, useMemo } from 'react'
import { AuthContext } from 'auth/AuthProvider'
import { getTenantId } from 'auth/FirebaseAuth'

export const useGetTenantId = () => {
	const context = useContext(AuthContext)
	return useMemo(() => getTenantId(context?.currentUser), [context?.currentUser])
}
